import React, {Component} from 'react';
import Highcharts from 'highcharts/highstock';
import API from './API';

class LargeChart extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.updateChart = this.updateChart.bind(this);
        this.createChart = this.createChart.bind(this);
    }

    componentWillMount() {
        API.getChartData(this.props.appState);
    }

    componentDidMount() {
        this.createChart();
    }

    //Destroy chart before unmount.
    componentWillUnmount() {
        this.chart.destroy();
    }

    createChart() {
        let that = this;
        let currency = this.props.appState.currency;
        let options = {
            chart: {
                renderTo: 'container',
                type: 'line'
            },
            title: {"text": ""},
            yAxis: {
                title: {
                    text:`Price (${currency.symbol})`,
                    margin: 54
                },
                labels: {
                    formatter: function () {
                        return currency.prefix + this.axis.defaultLabelFormatter.call(this) + currency.suffix;
                    },
                    align: 'right',
                    x: 44
                }
            },
            credits: {
                enabled: false
            },
            xAxis: {
                type: 'datetime',
            },
            data: {
                dateFormat: 'auto',
                firstRowAsNames: false
            },

            series: [{}],
            rangeSelector: {
                allButtonsEnabled: true,
                buttons: [
                    {type: 'all', count: 1, text: '1d', events: { click: () => { that.updateChartWithTime('day-1') } }},
                    {type: 'all', count: 1, text: '7d', events: { click: () => { that.updateChartWithTime('day-7') } }},
                    {type: 'all', count: 1, text: '1m', events: { click: () => { that.updateChartWithTime('month-1') } }},
                    {type: 'all', count: 3, text: '3m', events: { click: () => { that.updateChartWithTime('month-3') } }},
                    {type: 'all', count: 1, text: '1y', events: { click: () => { that.updateChartWithTime('year-1') } }},
                    {type: 'all', count: 1, text: 'YTD', events: { click: () => { that.updateChartWithTime('ytd') } }},
                    {type: 'all', text: 'ALL', events: { click: () => { that.updateChartWithTime('all') } }}],
                selected: 2,
                inputEnabled: true,
                enabled: this.props.isDesktop
            },
            navigator: {
                enabled: this.props.isDesktop
            },
            scrollbar: {
                enabled: this.props.isDesktop
            }
        };

        try {
            this.chart = new Highcharts.stockChart(
                'large-chart',
                options
            );

            this.chart.showLoading('<span>Loading </span><i class="glyphicon glyphicon-refresh spinning" />');
            this.chart.reflow();
            this.updateChart();
        } catch (err) {
            // Fix error
            //console.log(err);
        }
    }

    async updateChartWithTime(time) {
        let appState = this.props.appState;
        let data = await API.getChartDataWithTime(appState, time);
        data = this.convertDataToCurrency(data);
        let currency = appState.currency;

        // Set container which the chart should render to.
        let options = {
            series: [{
                data: data,
                name: `Price (${currency.symbol})`
            }]
        };

        try {
            this.chart.update(options);
            this.chart.hideLoading();
            this.chart.reflow();
            this.chart.xAxis[0].setExtremes();
        } catch (err) {
            // handle error?
        }
    }

    convertDataToCurrency(data) {
        let appState = this.props.appState;
        let currency = appState.currency;

        let newData = data.map(dataPoint => {
            let newValue = dataPoint[1] * currency.value;
            if (newValue > 10) {
                newValue = +newValue.toFixed(2);
            }

            if (newValue > 10000) {
                newValue = +newValue.toFixed(0);
            }

            let newCurrency = [dataPoint[0], newValue];
            return newCurrency;
        });

        return newData;
    }

    async updateChart() {
        let appState = this.props.appState;
        let data = await API.getChartData(appState);

        data = this.convertDataToCurrency(data);
        let currency = appState.currency;

        // Set container which the chart should render to.
        let options = {
            series: [{
                data: data,
                name: `Price (${currency.symbol})`
            }]
        };

        try {
            this.chart.update(options);
            this.chart.hideLoading();
            this.chart.reflow();
            this.chart.xAxis[0].setExtremes();
        } catch (err) {
            // handle error?
        }
    }


    render() {
        return (
            <div className="large-chart" id="large-chart"/>
        );
    }
}

export default LargeChart;



// WEBPACK FOOTER //
// ./src/LargeChart.js